/** Transaction jamais créée (utilisateur a abandonné avant ou création échouée). */
const TRANSACTION_NOT_FOUND_SIGNALS = [
  '821',
  'TRANSACTION_NOT_FOUND',
  'transaction not found',
  'transaction introuvable',
  'transaction_non_trouvée',
];

function normalizeSignal(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).trim().toUpperCase();
}

function matchesTransactionNotFound(value: string): boolean {
  const upper = value.toUpperCase();
  return TRANSACTION_NOT_FOUND_SIGNALS.some(s => upper === s.toUpperCase() || upper.includes(s.toUpperCase()));
}

function getPayloadCandidates(error: unknown): Record<string, unknown>[] {
  const err = error as { response?: { data?: unknown }; data?: unknown };
  const data = err?.response?.data ?? err?.data;
  if (!data || typeof data !== 'object') return [];
  const obj = data as Record<string, unknown>;
  const candidates: Record<string, unknown>[] = [obj];

  const inner = obj.data as Record<string, unknown> | undefined;
  if (inner && typeof inner === 'object') candidates.push(inner);

  const errObj = obj.error as Record<string, unknown> | undefined;
  if (errObj && typeof errObj === 'object') candidates.push(errObj);

  const errs = obj.errors as Record<string, unknown>[] | undefined;
  if (Array.isArray(errs) && errs[0] && typeof errs[0] === 'object')
    candidates.push(errs[0] as Record<string, unknown>);

  const body = obj.body as Record<string, unknown> | undefined;
  if (body && typeof body === 'object') candidates.push(body);

  return candidates;
}

function payloadMatches(payload: Record<string, unknown>): boolean {
  const code = payload?.code ?? payload?.errorCode ?? payload?.statusCode;
  const msg = payload?.message ?? payload?.error ?? payload?.errorMessage;
  const desc = payload?.description ?? payload?.errorDescription;

  if (normalizeSignal(code) === '821') return true;
  if (matchesTransactionNotFound(String(msg ?? ''))) return true;
  if (matchesTransactionNotFound(String(desc ?? ''))) return true;
  return false;
}

export function isTransactionNotFoundError(error: unknown): boolean {
  const candidates = getPayloadCandidates(error);
  return candidates.some(payloadMatches);
}
